import { Component, Inject, OnInit } from '@angular/core';
import { ViolationStatement } from '../../../../models/entities/violation-statement';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { GrowlerService } from '../../../../services/growler.service';
import { LobConsolidatedMailOptions } from '../../../../models/entities/lob-mail-options';
import { LobMailSendRequest } from '../../../../services/lob/lob-mail-send-request';
import { LobService } from '../../../../services/lob/lob.service';

export interface MailViolationDialogInput
{
    violations: ViolationStatement[];
    organizationId?: number;
}

@UntilDestroy()
@Component({
    selector: 'app-mail-violation-modal',
    templateUrl: './mail-violation-modal.component.html',
})
export class MailViolationModalComponent implements OnInit
{
    /** The violations to mail */
    violations: ViolationStatement[] = [];
    /** Track if they are sending mail / should disable button */
    isSendingMail = false;
    /** If any owner has a mailing address (for single violation mailer), show it */
    hasMailingAddress = false;
    /** Whether to show singular or plural */
    contextWord = 'violation';
    /** Mailing options, emitted from mail options component embed */
    options: LobConsolidatedMailOptions = null;

    constructor(
            private _dialogRef: MatDialogRef<MailViolationModalComponent>,
            private _growler: GrowlerService,
            private _lobService: LobService,
            @Inject(MAT_DIALOG_DATA) public data: MailViolationDialogInput,
    ) {
        this.violations = this.data.violations;
    }

    ngOnInit() {
        if (this.violations.length === 1) {
            for (const owner of this.violations[0].unit.owners) {
                if (owner.membership.profile.address1) {
                    this.hasMailingAddress = true;
                }
            }
        } else {
            this.contextWord = 'violations';
        }
    }

    /** Send the mailer */
    mailViolation() {
        this.isSendingMail = true;

        const request: LobMailSendRequest = new LobMailSendRequest({
            unitIds: [],
            ownerIds: [],
            violationIds: this.violations.map(v => v.id),
            doIncludeInvoices: false,
            options: this.options,
        });

        this._lobService.sendMailedViolations(request, this.data.organizationId).pipe(untilDestroyed(this)).subscribe({
            next: () => {
                this._growler.success('Violation Mailed', `We are processing your mailed ${this.contextWord}.`);
                this.close();
            },
            error: () => {
                this._growler.oops(`We were unable to mail your ${this.contextWord} at this time.`);
                this.close();
            }
        });
    }

    close() {
        this._dialogRef.close();
    }
}
